import { TFunction } from 'i18next';
import { IconFormNames } from 'shared/assets/icons';
import { Goal } from 'shared/types/goal';
import {
  goalInboxID,
  otherSectionID,
  overdueSectionID,
  unlinkedPlannedTasksID,
} from 'shared/types/orderable-section';
import { RoleOption } from 'shared/types/roles';
import { SortingMode } from 'shared/types/sorting-mode';

export enum GoalTypes {
  Inbox = 'inbox',
  Scheduled = 'scheduled',
  Overdue = 'overdue',
  Other = 'other',
}

const typeIdMap = {
  [GoalTypes.Inbox]: goalInboxID,
  [GoalTypes.Scheduled]: unlinkedPlannedTasksID,
  [GoalTypes.Overdue]: overdueSectionID,
  [GoalTypes.Other]: otherSectionID,
};

const typeLabelMap = {
  [GoalTypes.Inbox]: 'general.sections.inbox.title',
  [GoalTypes.Scheduled]: 'general.sections.goals.scheduled.title',
  [GoalTypes.Overdue]: 'general.sections.goals.overdue.title',
  [GoalTypes.Other]: 'general.sections.goals.other.title',
};

const typeIconMap = {
  [GoalTypes.Inbox]: IconFormNames.Inbox,
  [GoalTypes.Scheduled]: IconFormNames.CalendarUpcoming,
  [GoalTypes.Overdue]: IconFormNames.ClockWatch,
  [GoalTypes.Other]: IconFormNames.Target,
};

export const createInboxGoal = (t: TFunction, type = GoalTypes.Inbox): Goal => {
  return {
    completedAt: null,
    completedTaskCount: null,
    deadline: null,
    image: null,
    lifeAreaId: null,
    metric: null,
    parentIds: null,
    sections: null,
    sortingMode: SortingMode.Custom,
    startDate: null,
    taskCount: null,
    updatedAt: null,
    archivedAt: null,
    frozenAt: null,
    iconName: typeIconMap[type],
    roles: { [RoleOption.All]: [], [RoleOption.Owner]: '' },
    id: typeIdMap[type],
    goalSorting: null,
    createdAt: new Date(),
    taskSorting: null,
    name: t(typeLabelMap[type]),
  };
};
